<template>
  <div :class="['pt-4', theme.middleScreen.backgroundColor]">
    <modal
      name="security-code"
      width="92%"
      height="auto"
      :maxWidth="480"
      :adaptive="true"
      @opened="modalOpened()"
      @closed="modalClosed()"
    >
      <div class="flex flex-col min-h-full p-4">
        <div class="flex flex-col flex-grow">
          <p class="text-gray-500 text-xs regular text-center">
            <strong>{{ lang["please_enter_security_code"][language] }}</strong>
          </p>
          <div class="mb-4">
            <label
              class="block text-gray-700 text-sm font-bold mb-2"
              for="name"
              >{{ lang["security_code"][language] }}</label
            >
            <input
              autocomplete="false"
              aria-autocomplete="false"
              v-model="securityCode"
              name="security-code"
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="security-code"
              type="text"
              :placeholder="lang['security_code'][language]"
              @keyup.enter="initiatePayment(selectedPaymentType)"
            />
            <span
              :class="[
                isSecurityCodeValidated ? 'text-green-500' : 'text-red-500',
              ]"
              >{{ securityCodeValidationMessage }}</span
            >
          </div>
          <div>
            <button
              :disabled="!isSecurityCodeValidated"
              @click="initiatePayment(selectedPaymentType)"
              :class="[
                isSecurityCodeValidated ? 'bg-blue-500' : 'bg-gray-400',
                'text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline inline-flex items-center',
              ]"
              type="button"
            >
              <svg
                v-if="isSubmitting"
                style="animation: spin-animation 0.5s infinite"
                class="fill-current inline-block h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  class="heroicon-ui"
                  d="M6 18.7V21a1 1 0 0 1-2 0v-5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H7.1A7 7 0 0 0 19 12a1 1 0 1 1 2 0 9 9 0 0 1-15 6.7zM18 5.3V3a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h2.9A7 7 0 0 0 5 12a1 1 0 1 1-2 0 9 9 0 0 1 15-6.7z"
                />
              </svg>
              <span>{{ lang["submit"][language] }}</span>
            </button>
            <button
              @click="$modal.hide('security-code')"
              class="bg-gray-500 hover:bg-gray-700 ml-2 text-black font-bold py-2 px-2 rounded focus:outline-none focus:shadow-outline inline-flex items-center"
              type="button"
            >
              <span>{{ lang["cancel"][language] }}</span>
            </button>
          </div>
        </div>
      </div>
    </modal>
    <div class="w-full mx-auto">
      <div class="flex justify-center">
        <div
          :class="[
            'w-full flex flex-col items-center',
            theme.middleScreen.backgroundColor,
          ]"
        >
          <button
            v-for="paymentType in availablePaymentTypes"
            :key="paymentType.Id"
            @click="initiatePayment(paymentType)"
            :class="[
              theme.addToCart.backgroundColor,
              'flex justify-between px-10 py-4 w-3/4 rounded-md mb-2 shadow-lg transition duration-500 hover:shadow-xl',
              theme.body.textColor,
            ]"
          >
            <span>{{ paymentType[`name_${language}`] }}</span>
            <svg
              :class="[
                'fill-current inline-block',
                theme.paymentMethod.arrowTextolor,
              ]"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 9L16 12M16 12L13 15M16 12L8 12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#4A5568"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import sha256 from "js-sha256";
export default {
  data() {
    return {
      lang: lang,
      isSubmitting: false,
      isPaymentInitiated: false,
      securityCodeValidationMessage: "",
      isSecurityCodeValidated: false,
      selectedPaymentType: {},
    };
  },
  computed: {
    ...mapGetters([
      "menu",
      "theme",
      "menuHash",
      "language",
      "orderingSecurityCodeHash",
    ]),
    ...mapGetters("Cart", ["cartItems", "availablePaymentTypes", "tableId"]),
    securityCode: {
      get() {
        return this.$store.getters["Cart/securityCode"];
      },
      set(value) {
        if (!value) {
          this.securityCodeValidationMessage = "";
        }
        if (sha256(value).toUpperCase() == this.orderingSecurityCodeHash) {
          this.securityCodeValidationMessage = this.lang["valid_security_code"][
            this.language
          ];
          this.isSecurityCodeValidated = true;
        } else {
          this.securityCodeValidationMessage = this.lang[
            "invalid_security_code"
          ][this.language];
          this.isSecurityCodeValidated = false;
        }
        this.$store.commit("Cart/updateSecurityCode", value);
      },
    },
  },
  methods: {
    initiatePayment(paymentType) {
      this.selectedPaymentType = paymentType;
      if (
        paymentType.Label == "POS" &&
        this.orderingSecurityCodeHash != sha256("").toUpperCase() &&
        !this.isSecurityCodeValidated
      ) {
        this.$modal.show("security-code");
        return;
      }
      this.$modal.hide("security-code");
      this.$store.commit("startPageLoading");
      this.isPaymentInitiated = true;
      this.$store.commit("Cart/updatePaymentTypeId", paymentType.Id);
      this.$store.dispatch("Cart/UPDATE_ORDER").then(() => {
        this.$store
          .dispatch("Cart/INITIATE_TRANSACTION", paymentType.Id)
          .then((response) => {
            location.href = response.data.paymentUrl;
          });
      });
    },
    submitSecurityCode() {},
    modalOpened() {
      document.getElementById("security-code").focus();
    },
    modalClosed() {
      this.isSecurityCodeValidated = false;
      this.$store.commit("Cart/updateSecurityCode", "");
    },
  },
  mounted() {
    if (!this.cartItems.length) {
      if (this.menu.name_nl == "TAKE-AWAY") {
        this.$router.push(`/${this.$route.params.menuHash}`).catch(()=>{});
      } else {
        if (!this.menuHash || this.tableId == 0 || this.tableId == "") {
          if (localStorage.getItem("stickerId") !== 0) {
            this.$router.push(
              `/${this.$route.params.menuHash}/` +
                localStorage.getItem("stickerId")
            ).catch(()=>{});
          } else {
            this.$router.push(`/${this.$route.params.menuHash}`).catch(()=>{});
          }
        }
      }
    }

    if (this.availablePaymentTypes.length == 1) {
      this.$store.commit(
        "Cart/updatePaymentTypeId",
        this.availablePaymentTypes[0].Id
      );
      this.$store.dispatch("Cart/UPDATE_ORDER").then(() => {
        this.$store
          .dispatch(
            "Cart/INITIATE_TRANSACTION",
            this.availablePaymentTypes[0].Id
          )
          .then((response) => {
            location.href = response.data.paymentUrl;
          });
      });
    }
  },
};
</script>